import { Component, OnInit, HostListener, ViewChildren, QueryList } from '@angular/core';
import {
  NavigationService,
  IMenuItem,
  IChildItem
} from '../../../../services/navigation.service';
import { Router, NavigationEnd } from '@angular/router';
 
import { filter } from 'rxjs/operators';
import { Utils } from '../../../../utils';
 
@Component({
  selector: 'app-sidebar-large',
  templateUrl: './sidebar-large.component.html',
  styleUrls: ['./sidebar-large.component.scss']
})
export class SidebarLargeComponent implements OnInit {
  selectedItem: IMenuItem;
  nav: IMenuItem[];
 
  // Timeout used to delay closing when moving from main sidebar to child nav
  private closeTimeout: any;
 
  constructor(public router: Router, public navService: NavigationService) {
   
  }
 
  ngOnInit() {
    this.updateSidebar();
    // CLOSE SIDENAV ON ROUTE CHANGE
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(routeChange => {
        this.closeChildNav();
        if (Utils.isMobile()) {
          this.navService.sidebarState.sidenavOpen = false;
        }
      });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(routeChange => {
        this.closeChildNav();
        if (Utils.isTablet()) {
          this.navService.sidebarState.sidenavOpen = true;
        }
      });
 
 
 
 
 
      // this.nav = this.navService.filterMenuByPermissions();
 
 
 
    this.navService.menuItems$.subscribe(items => {
      this.nav = items;
      this.setActiveFlag();
    });
  }
 
  // Close child navigation when hovering over a top-level link item (e.g., Payments)
  onHoverLink(item) {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    this.navService.sidebarState.childnavOpen = false;
    this.setActiveMainItem(item);
  }
 
  selectItem(item) {
    // moving onto a new item should keep child nav open and cancel any pending close
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    this.navService.sidebarState.childnavOpen = true;
    this.navService.selectedItem = item;
    this.setActiveMainItem(item);
 
    // Scroll to top secondary sidebar
    setTimeout(() => {            
      // this.psContainerSecSidebar.update();
      // this.psContainerSecSidebar.scrollToTop(0, 400);
    });
  }
  closeChildNav() {
    this.navService.sidebarState.childnavOpen = false;
    this.setActiveFlag();
  }
 
  // Called when cursor leaves the main sidebar area
  onMainSidebarLeave() {
    // Give a brief window to allow pointer to enter the child nav without closing
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
    this.closeTimeout = setTimeout(() => {
      this.closeChildNav();
      this.closeTimeout = null;
    }, 200);
  }
 
  // Called when cursor enters the child nav area; prevent pending close
  onChildNavEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }
 
  // Called when leaving child nav; close immediately
  onChildNavLeave() {
    this.closeChildNav();
  }
 
  onClickChangeActiveFlag(item) {
    this.setActiveMainItem(item);
  }
  setActiveMainItem(item) {
    this.nav.forEach(i => {
      i.active = false;
    });
    item.active = true;
  }
 
  setActiveFlag() {
    if (window && window.location) {
      const activeRoute = window.location.hash || window.location.pathname;
      // Most specific match wins, so '/environment-config' isn't also active on '/environment-config/manage'
      const matchedItem = this.nav
        .filter(item => item.state && activeRoute.indexOf(item.state) !== -1)
        .sort((a, b) => b.state.length - a.state.length)[0];
      this.nav.forEach(item => {
        item.active = false;
        if (item === matchedItem) {
          this.navService.selectedItem = item;
          item.active = true;
        }
        if (item.sub) {
          item.sub.forEach(subItem => {
            subItem.active = false;
            if (activeRoute.indexOf(subItem.state) !== -1) {
              this.navService.selectedItem = item;
              item.active = true;
            }
            if (subItem.sub) {
              subItem.sub.forEach(subChildItem => {
                if (activeRoute.indexOf(subChildItem.state) !== -1) {
                  this.navService.selectedItem = item;
                  item.active = true;
                  subItem.active = true;
                }
              });
            }
          });
        }
      });
    }
  }
 
  updateSidebar() {
    if (Utils.isMobile()) {
      this.navService.sidebarState.sidenavOpen = true;
      this.navService.sidebarState.sideIcon = true;
      this.navService.sidebarState.childnavOpen = false;
    }
   else if (Utils.isTablet()) {
      this.navService.sidebarState.sidenavOpen = true;
      this.navService.sidebarState.sideIcon = true;
      this.navService.sidebarState.childnavOpen = false;
    } else {
      this.navService.sidebarState.sidenavOpen = true;
      this.navService.sidebarState.sideIcon = true;
    }
  }
 
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateSidebar();
  }
}
 